<div class="animated fadeIn backend">
    <div class="row">
        <div class="col-12">
            <div class="top-header-area">
                <div class="header-area mb-0">
                    <h3>Planting Sites</h3> 
                </div>
                <div class="total-planted">Total planted trees: {{totalPlantedTrees | number}}</div>
                <div class="button-area">

                    <form class="input-group search ">
                        <input type="text"
                               name="search"
                               [(ngModel)]="searchText"
                               [ngModelOptions]="{updateOn: 'submit'}"
                               (ngModelChange)="searchChanged()"
                               class="form-control" 
                               placeholder="Search..."
                               aria-label="Search..."
                               aria-describedby="basic-addon2">
                        <div class="input-group-append">
                            <button class="btn" type="submit"><i class="icon-magnifier"></i></button>
                        </div>

                        <div class="form-inline ml-4">                       
                            <select class="form-control select-site" name="siteType"[(ngModel)]="sortMissingType" (ngModelChange)="changeSortMissingSites()" >   
                                <option  *ngFor="let sort of sortByMissingDirections" value="{{sort.value}}" [selected]="sort.value === sortMissingType" >{{sort.description}}
                                </option>                              
                            </select>
                        </div>
                    </form>            
             
                    <div class="form-inline">
                        <label for="name">Items per page</label>
                        <select class="form-control custom-select" 
                            name="customerType" [(ngModel)]="pageSize" (ngModelChange)="updatePageSize()">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <button type="button"
                            class="btn btn-primary"
                            *ngIf="currentUser?.permissions.canManagePlantingSites && showAddNew"
                            [routerLink]="['/admin', 'plantingSites', 'new']">
                        <i class="icon-plus icons"></i> Add
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 planting-sites">
            <app-filter-list [plantingSites]="unfilteredSites"
                             class="filter-list"></app-filter-list>
            <div class="data-area">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>
